import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      Fred is great!
    </div>
  );
}

export default App;
